import { auditListRequest, auditListResponse } from '../../../../../backend/features/types/shared/auditList';
export const accountAuditListDef = {
    name: 'accountAuditList',
    requestSchema: auditListRequest,
    responseSchema: auditListResponse,
};
